export default __webpack_public_path__ + "static/Architecture1-52f926fb9580b831744975ab34c42f33.png";